import { message, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import Uploader from 'common/components/v2/common/uploader';
import styled from 'styled-components';

interface AiTeacherResourceUploadProp {
  url: string;
  accept?: string;
  callback?: any;
  styles: any;
  type: 'image' | 'video';
}

const Container = styled.div`
  position: relative;
  border: 1px dashed #1890ff;
  overflow: hidden;
  .ant-spin-nested-loading,
  .ant-spin-container {
    height: 100%;
  }
`;

const AiTeacherResourceUpload = (props: AiTeacherResourceUploadProp) => {
  const { url, accept, callback, styles, type } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(url);

  useEffect(() => {
    setPreviewUrl(url);
  }, [url]);

  const getUploadUrl = (fileName: string) => {
    return nx.$api
      .generate_aot_upload_presigned({ fileName })
      .then(res => {
        const { uploadUrls, accessUrl, contentType } = res;
        return { uploadUrls, accessUrl, contentType };
      })
      .catch(err => {
        message.error(err.message);
      });
  };

  const handleChange = async inEvent => {
    const { file } = inEvent.target.value;
    if (!file) {
      callback('');
      return Promise.resolve();
    }
    setIsLoading(true);
    const { uploadUrls, accessUrl, contentType } = await getUploadUrl(file.name);
    fetch(uploadUrls, {
      method: 'put',
      headers: { 'Content-Type': contentType },
      body: file,
    })
      .then(res => {
        message.success('上传成功！');
        setPreviewUrl(accessUrl);
        callback(accessUrl);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleError = inEvent => {
    const { value } = inEvent.target;
    if (value === 'size') {
      message.error('视频大小控制在300MB以内');
    }
  };

  return (
    <Container data-loading={isLoading} className="is-buggy-upload" style={{ ...styles }}>
      <Spin spinning={isLoading} tip="上传中...">
        <Uploader
          maxSize={314572800}
          accept={accept}
          type={type}
          onChange={handleChange}
          onError={handleError}
          value={previewUrl}
        />
      </Spin>
    </Container>
  );
};

export default AiTeacherResourceUpload;
